export enum VideoModes {
  NORMAL = "NORMAL",
  PICTURE_IN_PICTURE = "PICTURE_IN_PICTURE",
}
